import { createSelector } from '@reduxjs/toolkit';

import { diagramSnapshotSelector } from 'src/selectors/diagramSnapshot';
import { projectSelector } from 'src/selectors/project';

export const projectModelIdsByIriSelector = (projectId: string) =>
  createSelector(
    projectSelector(projectId),
    diagramSnapshotSelector(projectId),
    (project, diagram) =>
      project && diagram
        ? Object.fromEntries(
            Object.entries(diagram.model.modelData.modelsByIri).filter(
              ([id]) => !diagram.model.modelData.deletedModelIds?.includes(id)
            )
          )
        : {}
  );
